<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddElectricLine">Add Electric Line</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="electricLines" :options="options" :theme="theme" id="dataTable" ref="dataTable">
        <template slot="isEnabled" slot-scope="data">
          {{getIsEnabledLable(data.row)}}
        </template>
        <template slot="actions" slot-scope="data">
          <b-btn size="sm" variant="outline-primary" @click="showEditElectricLine(data.row)" class="mr-1">Edit</b-btn>
        </template>

      </v-client-table>
    </b-card>
    <div>
      <b-modal ref="modalEditElectricLine" title="Edit Electric Line" hide-footer @hide="hideEditElectricLine">
        <electric-line-edit v-if="selectedElectricLine" :electricLine="selectedElectricLine" @success="editElectricLineSuccess" @cancel="cancelEditElectricLine" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalAddElectricLine" title="Add Electric Line" hide-footer >
        <electric-line-add  @success="addElectricLineSuccess" @cancel="cancelAddElectricLine" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import ElectricLineEdit from './ElectricLineEdit'
  import ElectricLineAdd from './ElectricLineAdd'


  export default {
    name: 'ElectricLineList',
    components: {
      ElectricLineEdit,
      ElectricLineAdd
    },

    data: function() {
      return {
        selectedElectricLine: null,
        columns: ['lineName', 'description', 'isEnabled', 'actions'],
        options: {
          headings: {
            id: 'Name',
            description: 'Description',
            isEnabled: 'Enabled?'
          },
          sortable: ['lineName'],
          filterable: ['lineName', 'description'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      electricLines(){
        return this.$store.state.electrical.electricLines;
      }
    },
    methods: {
      showAddElectricLine(){
        this.$refs.modalAddElectricLine.show();
      },
      cancelAddElectricLine() {
        this.$refs.modalAddElectricLine.hide()
      },
      addElectricLineSuccess() {
        this.$refs.modalAddElectricLine.hide();
        this.$store.dispatch('electrical/getElectricLines')
      },
      getIsEnabledLable(electricLine){
         return electricLine.isEnabled == true ? 'Yes' : 'No';
      },
      showEditElectricLine(electricLine) {
        this.selectedElectricLine = electricLine
        this.$refs.modalEditElectricLine.show()
      },
      cancelEditElectricLine() {
        this.$refs.modalEditElectricLine.hide()
      },
      editElectricLineSuccess() {
        this.$refs.modalEditElectricLine.hide();
        this.$store.dispatch('electrical/getElectricLines')
      },
      hideEditElectricLine() {
        this.selectedElectricLine = null
      },
    },
    created() {
      if (this.$store.state.electrical.electricLines.length == 0) {
        this.$store.dispatch('electrical/getElectricLines');
      }
    }
  }
</script>

<style lang="css">
</style>
